import gql from 'graphql-tag'

export const routinesQuery = gql`
  query routinesQuery($userId: ID!, $dayS: DateTime, $dayE: DateTime) {
    allRoutines(
      filter: { AND: [{ type: "recur" }, { user: { id: $userId } }] }
    ) {
      id
      name
      type
      frequency
      routines(
        filter: {
          AND: [
            { type: "one" }
            { dateStart_gte: $dayS }
            { dateStart_lte: $dayE }
          ]
        }
      ) {
        id
      }
      groups(filter: { AND: [{ type: "recur" }, { user: { id: $userId } }] }) {
        id
        name
        color
        startedAt
        completedAt
        type
        trackers {
          id
          name
          color
          type
        }
        groups(
          filter: {
            AND: [
              { type: "one" }
              {
                OR: [
                  { AND: [{ startedAt_gte: $dayS }, { startedAt_lte: $dayE }] }
                  {
                    AND: [
                      { completedAt_gte: $dayS }
                      { completedAt_lte: $dayE }
                    ]
                  }
                ]
              }
            ]
          }
        ) {
          id
          startedAt
          completedAt
          minutesTotal
          isCompleted
          type
        }
      }
    }
  }
`

export const routinesListQuery = gql`
  query routinesListQuery($userId: ID!) {
    allRoutines(
      filter: { AND: [{ type: "recur" }, { user: { id: $userId } }] }
    ) {
      id
      name
    }
  }
`

export const routineQuery = gql`
  query routineQuery($id: ID!) {
    Routine(id: $id) {
      id
      name
      frequency
      groups(filter: { type: "recur" }) {
        id
        name
        color
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/graphql/queries/routine.js